import { render, staticRenderFns } from "./Traffic.vue?vue&type=template&id=7af41d2d&scoped=true"
import script from "./Traffic.vue?vue&type=script&lang=js"
export * from "./Traffic.vue?vue&type=script&lang=js"
import style0 from "./Traffic.vue?vue&type=style&index=0&id=7af41d2d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af41d2d",
  null
  
)

export default component.exports